import { render, staticRenderFns } from "./PortalFooter.vue?vue&type=template&id=bf2722c6&scoped=true"
import script from "./PortalFooter.vue?vue&type=script&lang=js"
export * from "./PortalFooter.vue?vue&type=script&lang=js"
import style0 from "./PortalFooter.vue?vue&type=style&index=0&id=bf2722c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf2722c6",
  null
  
)

export default component.exports